import { getImageUrlStr } from "../../../../utils/courseData";
import { Link } from "react-router-dom";

const CourseDetailContent = ({ detailData }) => {
  return (
    <>
      <div className="p-course__courseinfo">
        <ul className="p-course-cat">
          {detailData.categories ? (
            detailData.categories.split(",").map((ctg, index) => {
              return (
                <li className="p-course-cat__item" key={index}>
                  {ctg}
                </li>
              );
            })
          ) : (
            <></>
          )}
        </ul>
        <>
          {detailData.applicant_id ? (
            <div className="p-course-status">
              <p className="p-course-status__item">申込中</p>
            </div>
          ) : (
            <></>
          )}
        </>
      </div>
      <h1 className="p-heading01">{detailData.course_name}</h1>
      <p className="p-course-page__date">{detailData.period}</p>
      <div className="p-course-page__body">
        <div className="p-course-page__col01">
          <img
            src={
              detailData.image
                ? getImageUrlStr(detailData.image)
                : "/common/assets/images/logo02.svg"
            }
            alt={detailData.course_name}
          />
        </div>
        <div className="p-course-page__col02">
          <h2 className="p-course-page__heading">申込期間</h2>
          <p>
            {detailData.period_f}～{detailData.period_t}
          </p>
          <h2 className="p-course-page__heading">実施機関</h2>
          <p>{detailData.organ}</p>
          <h2 className="p-course-page__heading">定員</h2>
          <p>{detailData.capacity}</p>
          <h2 className="p-course-page__heading">全回数</h2>
          <p>{detailData.all_times ? detailData.all_times + "回" : ""}</p>
          <h2 className="p-course-page__heading">受講料</h2>
          <p>{detailData.tuition_fee ? detailData.tuition_fee + "円" : ""}</p>
          <h2 className="p-course-page__heading">会場</h2>
          <p>{detailData.venue}</p>
          <p>{detailData.venue_detail ? detailData.venue_detail : ""}</p>
          <h2 className="p-course-page__heading">単位</h2>
          <p>{detailData.unit}</p>
          <h2 className="p-course-page__heading">材料費</h2>
          <p>{detailData.material_cost}</p>
          <h2 className="p-course-page__heading">カテゴリー</h2>
          <p>{detailData.keyword}</p>
          <>
            {detailData.how_to_apply ? (
              <>
                <h2 className="p-course-page__heading">申込方法</h2>
                <p>{detailData.how_to_apply}</p>
                {detailData.apply_url ? (
                  <p>
                    <a
                      href={detailData.apply_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {detailData.apply_url_text
                        ? detailData.apply_url_text
                        : detailData.apply_url}
                      （新しいウィンドウで開きます）
                    </a>
                  </p>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <></>
            )}
          </>
          <p className="mt-5">
            <Link
              to={detailData.permalink}
              target="_blank"
              rel="noopener noreferrer"
            >
              詳しい講座内容はこちら（新しいウィンドウで開きます）
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default CourseDetailContent;
